import { STUDY_LANDSCAPES, type LandscapeId } from "@/features/story/data/landscapes";

export type HubPeriodId = "2005-2025" | "2005-2015" | "2015-2025";

export type HubPeriod = {
  readonly id: HubPeriodId;
  readonly label: string;
  readonly dateFrom: string;
  readonly dateTo: string;
  readonly yearFrom: number;
  readonly yearTo: number;
};

export const HUB_PERIODS: readonly HubPeriod[] = [
  {
    id: "2005-2025",
    label: "2005 → 2025",
    dateFrom: "2005-01-01",
    dateTo: "2025-12-31",
    yearFrom: 2005,
    yearTo: 2025,
  },
  {
    id: "2005-2015",
    label: "2005 → 2015",
    dateFrom: "2005-01-01",
    dateTo: "2015-12-31",
    yearFrom: 2005,
    yearTo: 2015,
  },
  {
    id: "2015-2025",
    label: "2015 → 2025",
    dateFrom: "2015-01-01",
    dateTo: "2025-12-31",
    yearFrom: 2015,
    yearTo: 2025,
  },
] as const;

export function hubPeriodsForLandscape(landscapeId: LandscapeId): readonly HubPeriod[] {
  if (landscapeId !== "kounounkan") return HUB_PERIODS;
  return HUB_PERIODS.filter((period) => period.yearFrom !== 2015 && period.yearTo !== 2015);
}

export type HubLanguage = "fr" | "en";

function isLandscapeId(value: string): value is LandscapeId {
  return STUDY_LANDSCAPES.some((p) => p.id === value);
}

function isPeriodId(value: string): value is HubPeriodId {
  return HUB_PERIODS.some((p) => p.id === value);
}

export function parseLandscapeSelect(value: string): LandscapeId | null {
  return isLandscapeId(value) ? value : null;
}

export function parsePeriodSelect(value: string): HubPeriodId | null {
  return isPeriodId(value) ? value : null;
}
